import styled, { keyframes, createGlobalStyle } from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { InputStyles } from '@rsos/components/capstone/base/form/inputs/InputText/InputText.styles';
import { StyledContainer } from '../../MapCard/MapCard.styles';

const CONTAINER_WIDTH = 358;
const CONTAINER_HEIGHT = 575;

export const OverridedAirAmbulanceStyledContainer = createGlobalStyle`
  ${StyledContainer} {
    max-width: ${CONTAINER_WIDTH}px;
    max-height: ${CONTAINER_HEIGHT}px;
    overflow-y: auto;
    overflow-x: hidden;

    /* Hide scrollbar for Chrome, Safari, and Edge */
    &::-webkit-scrollbar {
      display: none;
    }

    /* Hide scrollbar for Firefox */
    scrollbar-width: none;

    /* Hide scrollbar for IE, Edge, and older browsers */
    -ms-overflow-style: none;
  }
`;

export const Label = styled(Box).attrs({
  color: 'secondaryText',
  pb: 2,
})`
  opacity: ${p => (p.isDisabled ? 0.4 : 1)};
`;

export const ButtonContainer = styled(Box).attrs(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
}))``;

export const TextArea = styled.textarea`
  ${InputStyles}
  resize: none;
  overflow: auto;
  max-height: 104px;
  height: auto;
  padding: 5px 10px;
`;

const wave = keyframes`
  0%, 40%, 100% {
    transform: scaleY(0.6);
  }
  20% {
    transform: scaleY(1);
  }
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${({ fluid }) => (fluid ? '100%' : '60px')};
  height: 60px;
`;

const LoaderBars = styled.div`
  display: flex;
  justify-content: space-between;
  width: 20px;
  height: 23px;
`;

const LoaderBar = styled.div`
  display: inline-block;
  width: 3px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.background};
  animation: ${wave} 1.2s infinite ease-in-out;
  &:nth-child(1) {
    animation-delay: -1.2s;
  }
  &:nth-child(2) {
    animation-delay: -1.1s;
  }
  &:nth-child(3) {
    animation-delay: -1s;
  }
  &:nth-child(4) {
    animation-delay: -0.9s;
  }
  &:nth-child(5) {
    animation-delay: -0.8s;
  }
`;

export const Loader = () => (
  <LoaderContainer>
    <LoaderBars>
      <LoaderBar />
      <LoaderBar />
      <LoaderBar />
      <LoaderBar />
      <LoaderBar />
    </LoaderBars>
  </LoaderContainer>
);
